import {axiosGetAuthorize, axiosPostAuthorize} from '../AxiosRequests';
import {GetVendorGroupsList,DeleteVendorGroups,UpdateVendorGroups,GetVendorGroupsById,AddVendorGroups} from '../ApiEndPoints';

export default class VendorGroupServices {

        //** Call API : Get Vendor Group List */
        async addVendorGroups(request){
            return axiosPostAuthorize(AddVendorGroups, request);
        }
         
        async updateVendorGroups(request){
            return axiosPostAuthorize(UpdateVendorGroups, request);
        }

        async deleteVendorGroups(request){
            return axiosPostAuthorize(DeleteVendorGroups,request);
        }

        async getVendorGroupsList(request){
            return axiosPostAuthorize(GetVendorGroupsList, request);
        }

        async getVendorGroupsById(request){
            return axiosGetAuthorize(GetVendorGroupsById, request);
        }
        
       
        
}